export default __webpack_public_path__ + "static/BAT-882dd3a9fa346891b928f6151fecfe02.png";